<div fxLayout="column" fxLayoutAlign="start center" class="m-1 p-1 pb-2 h-100">
  <mat-card fxFlex fxLayout="column" class="w-100" ngClass.gt-xs="w-100-gt-xs">

    <mat-card-header fxLayout="column" fxLayoutAlign="stretch">
      <mat-card-title>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <span>{{ 'CUSTOMER.NEW-PATIENT' | translate }}</span>

          <button mat-stroked-button class="m-1" (click)="onBack($event)">
            <span class="pl-1 pr-1">{{ 'FUTURE-VISITS.BACK' | translate}}</span>
            <mat-icon matSuffix class="primary-color">navigate_before</mat-icon>
          </button>
        </div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content fxFlex="auto" perfectScrollbar class="pl-1 pr-1 mb-0" style="overflow-y: auto;">
      <!-- <div style="width:100%; background-color:blueviolet; height: 900px;"></div> -->
      <!-- <app-dynamic-form [questions]="questions"></app-dynamic-form>       -->
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">

        <mat-form-field class="w-100">
          <mat-label> {{ 'CUSTOMER.FORENAME' | translate }}<span class="accent-color">*</span></mat-label>
          <input matInput type="text" formControlName="FirstName" maxlength="20" autocomplete="off">
          <mat-error *ngIf="form.controls.FirstName.errors?.maxlength">{{ 'ERROR.MAXLENGTH' | translate: { length: 20} }} </mat-error>
          <mat-error *ngIf="form.controls.FirstName.errors?.minlength">{{ 'ERROR.MINLENGTH' | translate: { length: 2} }}</mat-error>
          <mat-error *ngIf="f.FirstName.errors?.required || f.FirstName.errors?.whitespace">
            {{ 'COMMON.REQUIRED' | translate }} </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label> {{ 'CUSTOMER.SURNAME' | translate }} <span class="accent-color">*</span></mat-label>
          <input matInput type="text" formControlName="LastName" maxlength="20" autocomplete="off">
          <mat-error *ngIf="form.controls.LastName.errors?.maxlength">{{ 'ERROR.MAXLENGTH' | translate: { length: 20} }}</mat-error>
          <mat-error *ngIf="form.controls.LastName.errors?.minlength">{{ 'ERROR.MINLENGTH' | translate: { length: 2} }}</mat-error>
          <mat-error *ngIf="f.LastName.errors?.required || f.LastName.errors?.whitespace">{{ 'COMMON.REQUIRED' | translate }} </mat-error>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="30">
            <mat-form-field class="w-100">
              <mat-select formControlName="IDNumberType">
                <mat-option *ngFor="let identityType of idTypes" [value]="identityType.value">{{identityType.text}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="f.IDNumberType.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="60">
            <mat-form-field class="w-100">
              <mat-label> {{  getTypeText() }} <span *ngIf="requiredFields['IDNumber']" class="accent-color">*</span></mat-label>
              <input matInput type="text" formControlName="IDNumber" [maxlength]="idMaxLength" appNumbersOnly
                autocomplete="off" inputmode="numeric">
              <mat-error *ngIf="f.IDNumber.hasError('required') || f.IDNumber.hasError('whitespace')">
                {{ 'COMMON.REQUIRED' | translate}}</mat-error>
              <mat-error *ngIf="f.IDNumber.hasError('invalidIsraelID')">{{ 'CUSTOMER.INVALID-ID-NUMBER' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.GENDER' | translate }} <span *ngIf="requiredFields['Gender']" class="accent-color">*</span></mat-label>
          <mat-select formControlName="Gender">
            <mat-option>{{ 'COMMON.SELECT' | translate}}</mat-option>
            <mat-option *ngFor="let currentGender of genders" [value]="currentGender.value">
              {{currentGender.text}}</mat-option>
          </mat-select>
          <mat-error *ngIf="f.Gender.errors?.required">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'CUSTOMER.BIRTH-DATE' | translate }} <span *ngIf="requiredFields['BirthDate']" class="accent-color">*</span></mat-label>
          <input matInput [matDatepicker]="birthDatepicker" formControlName="BirthDate" autocomplete="off"
            [max]="maxBirthDate">
          <mat-datepicker-toggle matSuffix [for]="birthDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatepicker></mat-datepicker>
          <mat-error *ngIf="f.BirthDate.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'CUSTOMER.MOBILE-PHONE' | translate }}  <span *ngIf="requiredFields['Mobile']" class="accent-color">*</span></mat-label>
          <input matInput formControlName="Mobile" autocomplete="off" appPhoneNumber maxlength="15">
          <mat-error *ngIf="f.Mobile.hasError('invalidPhone')">{{ 'ERROR.PHONE-INVALID' | translate}}</mat-error>
          <mat-error *ngIf="f.Mobile.hasError('missingPhoneOrEmail') || f.Mobile.hasError('required')">{{ 'COMMON.MOBILE-REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.EMAIL' | translate }} <span *ngIf="requiredFields['Email']" class="accent-color">*</span></mat-label>
          <input matInput type="email" formControlName="Email" autocomplete="off" maxlength="25">
          <mat-error *ngIf="f.Email.hasError('invalidEmail')">{{ 'ERROR.EMAIL-INVALID' | translate}}</mat-error>
          <mat-error *ngIf="f.Email.hasError('missingPhoneOrEmail') || f.Email.hasError('required')">{{ 'COMMON.EMAIL-REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.ADDRESS' | translate }} <span *ngIf="requiredFields['Address']" class="accent-color">*</span></mat-label>
          <input matInput type="text" formControlName="Address" autocomplete="off" maxlength="25">
          <mat-error *ngIf="f.Address.hasError('required')">{{ 'ERROR.ADDRESS-REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.CITY' | translate }} <span *ngIf="requiredFields['CityID']" class="accent-color">*</span></mat-label>
          <mat-select formControlName="CityID">
            <mat-option>{{ 'COMMON.SELECT' | translate}}</mat-option>
            <mat-option *ngFor="let currentCity of cities" [value]="currentCity.Value">
              {{currentCity.Text}}</mat-option>
          </mat-select>
          <mat-error *ngIf="f.CityID.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{ 'COMMON.THERAPIST' | translate }} <span *ngIf="requiredFields['TherapistID']" class="accent-color">*</span></mat-label>
          <mat-select formControlName="TherapistID">
            <mat-option>{{ 'COMMON.SELECT' | translate}}</mat-option>
            <mat-option *ngFor="let currentTherapist of therapists" [value]="currentTherapist.Value">
              {{currentTherapist.Text}}</mat-option>
          </mat-select>
          <mat-error *ngIf="f.TherapistID.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
        </mat-form-field>

        <section class="horizontal-section">
          <mat-label>{{ 'CUSTOMER.PREFERRED-NOTIFICATIONS' | translate }}: </mat-label>
          <mat-checkbox class="horizontal-margin" formControlName="NotificationBySms"
            (change)="notificationChanged($event, 'SMS')">
            SMS</mat-checkbox>
          <mat-checkbox class="horizontal-margin" formControlName="NotificationByEmail"
            (change)="notificationChanged($event,'Email')">{{ 'COMMON.EMAIL' | translate }}</mat-checkbox>
          <mat-checkbox *ngIf="isWhatsAppEnabled" class="horizontal-margin" formControlName="NotificationByWhatsApp"
            (change)="notificationChanged($event,'WhatsApp')">{{ 'COMMON.WHATSAPP' | translate }}</mat-checkbox>
          <mat-checkbox class="horizontal-margin" formControlName="DoNotNotificate"
            (change)="notificationChanged($event,'None')">
            {{ 'COMMON.NONE' | translate }}</mat-checkbox>
            <mat-error *ngIf="f.PreferredNotifications.hasError('required')">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
        </section>


        <div *ngFor="let field of additionalFields; index as ind;">

          <div [ngSwitch]="field.fieldType">

            <mat-form-field *ngSwitchCase="FIELD_TYPE_TEXT" class="w-100">
              <mat-label [attr.for]="field.name">{{ field.alias || field.name }} <span *ngIf="field.required"
                  class="accent-color">*</span></mat-label>
              <input matInput [id]="field.name" [formControlName]="field.name" maxlength="15">
            </mat-form-field>

            <mat-form-field *ngSwitchCase="FIELD_TYPE_INTEGER" class="w-100">
              <mat-label [attr.for]="field.name">{{ field.alias || field.name }} <span *ngIf="field.required"
                  class="accent-color">*</span></mat-label>
              <input matInput [id]="field.name" [formControlName]="field.name" maxlength="15" type="number" spi>
            </mat-form-field>

            <mat-form-field *ngSwitchCase="FIELD_TYPE_DATE" class="w-100">
              <mat-label [attr.for]="field.name">{{ field.alias || filed.name }}<span *ngIf="field.required"
                  class="accent-color">*</span></mat-label>
              <input matInput [id]="field.name" [matDatepicker]="ind" [formControlName]="field.name">
              <mat-datepicker-toggle matSuffix [for]="ind"></mat-datepicker-toggle>
              <mat-datepicker #ind></mat-datepicker>
            </mat-form-field>

            <section *ngSwitchCase="FIELD_TYPE_CHECKBOX">
              <mat-checkbox [formControlName]="field.name">{{ field.alias }} <span *ngIf="field.required"
                  class="accent-color">*</span></mat-checkbox>
            </section>

            <mat-form-field *ngSwitchCase="FIELD_TYPE_DROPDOWN" class="w-100">
              <mat-label>{{ field.alias || filed.name }} <span *ngIf="field.required" class="accent-color">*</span>
              </mat-label>

              <mat-select [formControlName]="field.name">
                <mat-option>{{ 'COMMON.SELECT' | translate}}</mat-option>

                <ng-container *ngIf="field.name === 'DropDown1'">
                  <mat-option *ngFor="let dropdown1Item of dropdown1" [value]="dropdown1Item.Value">
                    {{dropdown1Item.Text}}</mat-option>
                </ng-container>

                <ng-container *ngIf="field.name === 'DropDown2'">
                  <mat-option *ngFor="let dropdown2Item of dropdown2" [value]="dropdown2Item.Value">
                    {{dropdown2Item.Text}}</mat-option>
                </ng-container>

                <ng-container *ngIf="field.name === 'DropDown3'">
                  <mat-option *ngFor="let dropdown3Item of dropdown3" [value]="dropdown3Item.Value">
                    {{dropdown3Item.Text}}</mat-option>
                </ng-container>


              </mat-select>
              <mat-error *ngIf="isValid(field.name)">{{ 'COMMON.REQUIRED' | translate}}</mat-error>
              
            </mat-form-field>

          </div>
        </div>

      </form>

      <!--  <div>{{ diagnostic }} </div> -->
    </mat-card-content>

    <mat-card-actions>
      <div fxLayoutAlign="center" class="p-2 pb-2">
        <button mat-raised-button color="accent" class="mat-elevation-z6" type="button" (click)="onSave($event)"
          [disabled]="!form.valid">
          <span class="pl-3 pr-3">{{ 'COMMON.SAVE' | translate }}</span>
        </button>
      </div>
      <mat-error fxLayoutAlign="center">{{ error }}</mat-error>
    </mat-card-actions>

  </mat-card>
</div>
